export default __webpack_public_path__ + "static/media/KIOSK_IKONA_GREEN.21ee3238.png";